import React from 'react';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import useDesktop from '@components/shared/useDesktop';
import { NAV_MENU_BREAKPOINT } from '@constants';
import { NavigationItem, NavigationPreview, NavigationSection } from '@contracts';
import NavMainMenuDesktop from './NavMainMenuDesktop';
import NavMainMenuMobile from './NavMainMenuMobile';

interface Props {
  periodCare: NavigationSection;
  vaginalHealth: NavigationSection;
  accessories: NavigationSection;
  aboutUs: NavigationSection;
  discover: NavigationSection;
  productCategories: NavigationPreview[];
  vitalsArticleUids: string[];
  policiesMenuItems: NavigationItem[];
}

const NavMainMenu: React.FC<Props> = ({
  periodCare,
  vaginalHealth,
  accessories,
  aboutUs,
  discover,
  productCategories,
  vitalsArticleUids,
  policiesMenuItems
}) => {
  const isDesktop = useDesktop(NAV_MENU_BREAKPOINT);

  return (
    <Wrapper>
      {isDesktop ? (
        <NavMainMenuDesktop
          periodCare={periodCare}
          vaginalHealth={vaginalHealth}
          accessories={accessories}
          aboutUs={aboutUs}
          discover={discover}
          productCategories={productCategories}
          vitalsArticleUids={vitalsArticleUids}
        />
      ) : (
        <NavMainMenuMobile
          periodCare={periodCare}
          vaginalHealth={vaginalHealth}
          accessories={accessories}
          aboutUs={aboutUs}
          discover={discover}
          productCategories={productCategories}
          policiesMenuItems={policiesMenuItems}
        />
      )}
    </Wrapper>
  );
};

export default NavMainMenu;

const Wrapper = styled.div`
  min-height: 100%;
  border-top: 1px solid ${Colors.ecru50};
  padding-top: 50px;
`;
